// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*\n * The hml-button-download-file class is used by the download links in HML source text popup dialogs\n * They're actually html <button>s that are styled to look like an <a>\n * See submission-history-table.component.html\n */\n.hml-button-download-file {\n    background-color: white;\n    border: none;\n    color: #00355E;\n    font-weight: bold;\n    text-decoration: underline;\n}\n\n.hml-button-download-file:hover {\n    text-decoration: none;\n}\n", ""]);
// Exports
module.exports = exports;
